<template>
  <div>
    <p><b>Gäste im {{ property }}</b></p>
    <el-dialog title="Einstellungen" :visible.sync="dialogFormVisible">
      <el-form :model="interval">
        <el-form-item label="Interval in MS:" label-width="220px">
          <el-input v-model="interval.interval_ms"></el-input>
        </el-form-item>
        <el-form-item label="Possible rows displayable:" label-width="220px">
          <el-input v-model="display.rows"></el-input>
        </el-form-item>
        <el-form-item label="Span:" label-width="220px">
          <el-input v-model="display.span"></el-input>
        </el-form-item>
        <p>The span defines the end lines of a items and when they should span more than one column, in short: you can imagine it to a width like behavior and define how wide the columns can be.</p>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogFormVisible = false">Schließen</el-button>
      </span>
    </el-dialog>
    <el-row :gutter="20">
      <el-col :span="display.span" v-for="list in guests">
        <div class="table">
          <el-table
          :data="list"
          stripe
          border
          style="width: 100%"
          :default-sort = "{prop: 'unit.name', order: 'ascending'}">
            <el-table-column
              width="50px"
              prop="unit.name"
              label="#">
            </el-table-column>
            <el-table-column
              prop="primaryGuest.lastName"
              label="Nachname">
            </el-table-column>
            <el-table-column
              prop="primaryGuest.firstName"
              label="Vorname">
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
  <el-row type="flex" class="row-bg" :gutter="20">
    <el-col :span="4">
      <el-button size="mini" @click="startstop" :icon="icon" circle></el-button>
      <el-button size="mini" @click="dialogFormVisible = true" icon="el-icon-setting" :disabled=dialogButtonActive circle></el-button>
    </el-col>
  </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
// const mapping = require('../helpers/mapping.json')

export default {
  data () {
    return {
      inHouse: null,
      guests: null,
      tokenMan: null,
      selected: null,
      interval: {
        interval: null,
        interval_ms: 60000,
        running: null
      },
      display: {
        rows: 13,
        span: 6
      },
      icon: 'el-icon-video-play',
      x: 0,
      dialogFormVisible: false,
      dialogButtonActive: false
    }
  },
  computed: {
    ...mapGetters({
      token: 'getAuthToken',
      property: 'getProperty'
    })
  },
  methods: {
    sleep (ms) {
      return new Promise(resolve => {
        console.log('sleeping')
        setTimeout(resolve, ms)
      })
    },
    getToken () {
      axios.get('https://us-central1-klingelplatten-360service.cloudfunctions.net/api/token/')
        .then(response => {
          this.$store.commit('setAuth', response.data.access_token)
        })
        .catch(error => {
          console.log(error)
        })
    },
    refreshToken () {
      console.log('refreshing Token')
      axios.get('https://us-central1-klingelplatten-360service.cloudfunctions.net/api/token/')
        .then(response => {
          this.$store.commit('setAuth', response.data.access_token)
          this.startstop()
        })
        .catch(error => {
          console.log(error)
        })
    },
    splicer (array, n) {
      var splicerLength = Math.max(array.length / n, 1)
      var splices = []
      for (var i = 0; i < n; i++) {
        if (splicerLength * (i + 1) <= array.length)splices.push(array.slice(splicerLength * i, splicerLength * (i + 1)))
      }
      return splices
    },
    async getReservations () {
      // Fetching the reservations from the Apaleo API
      console.log('FETCHING RESERVATIONS')
      const apiURL = 'https://api.apaleo.com/booking/v1/reservations?status=InHouse&propertyIds=' + this.property
      const auth = this.token
      axios.get(apiURL, { headers: { 'Authorization': auth } })
        .then(response => {
          if (response.status === 204) {
            return console.log('Empty result - doing nothing')
          } else {
            response.data.reservations.sort((a, b) => a.unit.name - b.unit.name)
            let arraysNeeded = Math.ceil(response.data.reservations.length / this.display.rows)
            this.guests = this.splicer(response.data.reservations, arraysNeeded)
            this.inHouse = response.data.reservations
          }
        })
        .catch(error => {
          // Note: If the token is invalid, we refetch a token and retry the getReservations() call until the new token is available
          if (error.response.status === 401) {
            this.startstop()
            this.refreshToken()
          }
          console.log('Error status', error)
        })
    },
    runInterval () {
      // We need to refetch the data of the Apaleo API in regular intervals, to assure that the latest guests are shown
      if (this.property) {
        console.log('Recurring fetch of transaction data started')
        this.interval.running = true
        this.icon = 'el-icon-video-pause'
        this.dialogButtonActive = true
        this.getReservations()
        this.interval.interval = setInterval(this.getReservations, this.interval.interval_ms)
      } else {
        this.$message.error('Kein Property ausgewählt!')
        this.storeProperty(this.$route.query.property)
      }
    },
    startstop () {
      if (this.interval.running === true) {
        clearInterval(this.interval.interval)
        this.icon = 'el-icon-video-play'
        this.dialogButtonActive = false
        this.interval.running = false
      } else {
        this.runInterval()
      }
    },
    storeProperty (arg) {
      this.$store.commit('setProperty', arg)
    }
  },
  mounted () {
    this.storeProperty(this.$route.query.property)
    axios.get('https://us-central1-klingelplatten-360service.cloudfunctions.net/api/token/')
      .then(response => {
        this.$store.commit('setAuth', response.data.access_token)
        this.runInterval()
      })
      .catch(error => {
        console.log(error)
      })
  },
  beforeDestroy () {
    clearInterval(this.interval.interval)
  }
}
</script>

<style scoped>
.table {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-items: center;
  align-items: center;
  align-content: center;
  max-width: 50em;
  margin-left: auto;
  margin-right: auto;
  position: relative;
}
</style>
